import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f0978342")

_pushScopeId("data-v-f0978342")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  for: "comment",
  class: "form-label"
}
const _hoisted_3 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_4 = {
  for: "commentExpanded",
  class: "form-label"
}
const _hoisted_5 = { class: "button-container" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "card-title d-flex justify-content-between" }
const _hoisted_10 = { class: "text-muted" }
const _hoisted_11 = {
  class: "modal fade",
  id: "_app_remove_confirm_note",
  tabindex: -1,
  "aria-hidden": "true"
}
const _hoisted_12 = { class: "modal-dialog modal-dialog-centered mw-450px" }
const _hoisted_13 = { class: "modal-content" }
const _hoisted_14 = { class: "modal-header" }
const _hoisted_15 = { class: "svg-icon svg-icon-1" }
const _hoisted_16 = { class: "modal-body scroll-y mx-5 mx-xl-15 my-5 text-center" }
const _hoisted_17 = { class: "my-9" }
const _hoisted_18 = { class: "actions text-center" }
const _hoisted_19 = { class: "indicator-label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Field = _resolveComponent("Field")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _directive_focus = _resolveDirective("focus")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!$setup.editing && !$setup.editingComment)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "mb-3",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.setEditing(true)))
        }, [
          _createVNode("label", _hoisted_2, _toDisplayString($setup.translate("note")), 1),
          _createVNode(_component_Field, {
            type: "text",
            class: "form-control form-control-solid",
            placeholder: $setup.translate('addNote'),
            name: "title readonly"
          }, null, 8, ["placeholder"])
        ]))
      : _createCommentVNode("", true),
    ($setup.editing)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("label", _hoisted_4, _toDisplayString($setup.editingComment ? $setup.translate("editNote") : $setup.translate("newNote")), 1),
          ($setup.editingComment)
            ? _withDirectives((_openBlock(), _createBlock("textarea", {
                key: 0,
                class: "form-control",
                id: "commentExpanded",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.editingComment.description = $event))
              }, null, 512)), [
                [_directive_focus],
                [_vModelText, $setup.editingComment.description]
              ])
            : _withDirectives((_openBlock(), _createBlock("textarea", {
                key: 1,
                class: "form-control",
                id: "commentExpanded",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($setup.newComment = $event))
              }, null, 512)), [
                [_directive_focus],
                [_vModelText, $setup.newComment]
              ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("button", {
                class: "btn btn-primary mt-2 btn-primary-action",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.saveComment && $setup.saveComment(...args)))
              }, _toDisplayString($setup.translate("Save")), 1),
              _createVNode("button", {
                class: "btn btn-secondary mt-2 ml-2 btn-primary-action",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.cancelComment && $setup.cancelComment(...args)))
              }, _toDisplayString($setup.translate("Cancel")), 1)
            ]),
            _createVNode("div", null, [
              ($setup.editingComment)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"])),
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#_app_remove_confirm_note",
                    "data-bs-placement": "top",
                    class: "btn btn-danger mt-2 btn-primary-action"
                  }, _toDisplayString($setup.translate("Delete")), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : (_openBlock(true), _createBlock(_Fragment, { key: 2 }, _renderList([...$setup.comments].reverse(), (comment, index) => {
          return (_openBlock(), _createBlock("div", { key: index }, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("h6", _hoisted_9, [
                  _createVNode("span", null, _toDisplayString($setup.getMembers(comment.user)), 1),
                  _createVNode("small", _hoisted_10, _toDisplayString($setup.formatDate(comment.created_at)), 1)
                ]),
                _createVNode("p", {
                  onClick: ($event: any) => ($setup.editComment(comment)),
                  class: "card-text mb-3"
                }, _toDisplayString(comment.description ? comment.description : "No Comment Provided"), 9, ["onClick"])
              ])
            ])
          ]))
        }), 128)),
    _createVNode("div", _hoisted_11, [
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _createVNode("h3", null, _toDisplayString($setup.translate("removingConfirmationTitle")), 1),
            _createVNode("button", {
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.cancelDeleteNote && $setup.cancelDeleteNote(...args))),
              type: "button",
              class: "btn btn-sm btn-icon btn-active-color-primary"
            }, [
              _createVNode("span", _hoisted_15, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Close.svg" })
              ])
            ])
          ]),
          _createVNode("div", _hoisted_16, [
            _createVNode("h2", null, _toDisplayString($setup.translate("removeNote")), 1),
            _createVNode("h5", _hoisted_17, _toDisplayString($setup.editingComment?.description), 1),
            _createVNode("div", _hoisted_18, [
              _createVNode("button", {
                type: "button",
                class: "btn btn-danger",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.deleteComment && $setup.deleteComment(...args)))
              }, [
                _createVNode("span", _hoisted_19, _toDisplayString($setup.translate("confirm")), 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
})